import { Flex, Grid, Image, Text } from '@chakra-ui/react'
import { Section } from '@/components/layout'
import { SectionLabel } from '@/components/typography'
import { useLocale } from '@/i18n'
import { COMPANIES, LOGOS_COPY } from './logos.data'

export const CompanyLogos = () => {
  const { locale } = useLocale()
  const logosCopy = LOGOS_COPY[locale]
  const companies = COMPANIES[locale]
  const withLogo = companies.filter((company) => company.logo)
  const withoutLogo = companies.filter((company) => !company.logo)

  return (
    <Section id="clients" pt="clamp(28px, 3.5vw, 40px)" pb="clamp(32px, 4vw, 48px)">
      <Flex align="baseline" gap="24px" flexWrap="wrap">
        <SectionLabel>{logosCopy.sectionLabel}</SectionLabel>
        <Text fontSize="13px" color="muted" maxW="62ch">
          {logosCopy.subtext}
        </Text>
      </Flex>
      <Grid
        templateColumns="repeat(auto-fill, minmax(118px, 1fr))"
        borderTop="2px solid"
        borderLeft="2px solid"
        borderColor="divider"
        mt="24px"
      >
        {withLogo.map((company) => (
          <Flex
            key={company.name}
            borderRight="2px solid"
            borderBottom="2px solid"
            borderColor="divider"
            h="84px"
            align="center"
            justify="center"
            p="14px"
          >
            <Image
              src={company.logo}
              alt={`${company.name} ${logosCopy.logoAltSuffix}`}
              w="100%"
              h={company.square ? '46px' : '26px'}
              objectFit="contain"
              filter="grayscale(1) brightness(0)"
              opacity={0.82}
            />
          </Flex>
        ))}
      </Grid>
      <Text
        mt="20px"
        fontSize="11px"
        lineHeight="1.6"
        letterSpacing="0.1em"
        textTransform="uppercase"
        color="muted"
      >
        {logosCopy.moreLabel} {withoutLogo.map((company) => company.name).join(' · ')}
      </Text>
    </Section>
  )
}
